import * as AutoCompleteConstants from "@/constants/auto-complete";

export function setAutoComplete(autoComplete, requestName) {
  return {
    type: AutoCompleteConstants.SET_AUTOCOMPLETE,
    requestName,
    autoComplete
  };
}